import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const myItemsApi = factory.get("myItems");

const initialState = {
  items: {
    data: [],
    loading: false,
    total: 0,
    filters: {
      skip: 0,
      page: 0,
      take: 25,
      item_id: null,
      location_id: null,
      location_type: "User",
      user_id: null,
      customer_id: null,
      is_damaged: null,
    },
    dialog: false,
    currentTab: 0,
    damagedDialog: {
      open: false,
      loading: false,
    },
  },
};

const myItemsSlice = createSlice({
  name: "myItems",
  initialState,
  reducers: {
    setData: (state, { payload }) => {
      state.items.data = payload.data;
      state.items.total = payload.total;
    },
    setLoading: (state, { payload }) => {
      state[payload].loading = !state[payload].loading;
    },
    setFilters: (state, { payload }) => {
      state.items.filters = {
        ...state.items.filters,
        ...payload,
      };
    },
    setTab: (state, { payload }) => {
      state.items.currentTab = payload;
      state.items.filters = {
        ...initialState.items.filters,
        location_type:
          payload === 1 ? "Store" : payload === 2 ? "Customer" : "User",
      };
    },
    resetFilters: (state) => {
      state.items.filters = {
        ...initialState.items.filters,
        location_type:
          state.items.currentTab === 1
            ? "Store"
            : state.items.currentTab === 2
              ? "Customer"
              : "User",
      };
    },
    setFiltersDialog: (state) => {
      state.items.dialog = !state.items.dialog;
    },
    setDamagedDialog: (state, { payload }) => {
      state.items.damagedDialog = {
        ...state.items.damagedDialog,
        ...payload,
      };
    },
  },
});

export const {
  setData,
  setLoading,
  setFilters,
  setTab,
  resetFilters,
  setFiltersDialog,
  setDamagedDialog,
} = myItemsSlice.actions;

export default myItemsSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("items"));
    const rawFilters = getState().myItems.items.filters;
    const filters = {
      ...rawFilters,
      item_id: rawFilters.item_id?.id || rawFilters.item_id,
      location_id: rawFilters.location_id?.id || rawFilters.location_id,
      user_id: rawFilters.user_id?.id || rawFilters.user_id,
      customer_id: rawFilters.customer_id?.id || rawFilters.customer_id,
      is_damaged: rawFilters.is_damaged === "1" ? true : rawFilters.is_damaged === "0" ? false : null,
    };
    const res = await myItemsApi.index(filters);
    dispatch(setData(res.data));
    dispatch(setLoading("items"));
  } catch (err) {
    dispatch(setLoading("items"));
    dispatch(
        showNotification({
          type: "error",
          message: err.response?.data?.message || "حدث خطأ ما",
        }),
      );
    throw new Error(err);
  }
};

const markAsDamaged = (sn) => async (dispatch, getState) => {
  try {
    dispatch(setDamagedDialog({ loading: true }));
    const res = await myItemsApi.changeIsDamaged({ sn });
    dispatch(showNotification({ message: "تم تغيير الحالة بنجاح", type: "success" }));
    dispatch(setDamagedDialog({ open: false, loading: false }));
    dispatch(index());
  } catch (err) {
    dispatch(setDamagedDialog({ loading: false }));
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0],
      }),
    );
  }
};

export const MyItemsAction = {
  index,
  markAsDamaged,
};
